import BaseView from "scripts/views/baseView";
import MediaSalvattoreGridView from "scripts/views/mediaSalvattoreGridView";
import templateCategoriesPageSalvattoreSubPage from "templates/categoriesPageSalvattoreSubPage.hbs";

class CategoriesPageSalvattoreSubPageView extends BaseView {
  get template() {
    return templateCategoriesPageSalvattoreSubPage;
  }

  constructor(options) {
    super(options);

    this.salvattoreView = this.addSubView(
      new MediaSalvattoreGridView({
        collection: this.collection,
      }),
    );
  }

  render() {
    this.$el.html(this.template());

    this.salvattoreView
      .appendTo(
        $("#bb-categories-page-salvattore-sub-page-salvattore-view-region"),
      )
      .render();

    return this;
  }

  sync() {
    return this.salvattoreView.fetch();
  }
}

export default CategoriesPageSalvattoreSubPageView;
